import { Component, input } from '@angular/core';

import { MessageService } from './messages.service';

@Component({
  standalone: false,
  selector: 'ingsv-adm-messages',
  templateUrl: './messages.template.html',
  styleUrls: ['./messages.styles.scss']
})
export class MessagesComponent {
  readonly message = input<any>();
  readonly type = input<any>();

  constructor(
    private messageService: MessageService
  ) {}

  getMessage(message): string {
    return this.messageService.notificationMessages[message] ?
      this.messageService.notificationMessages[message] : message;
  }
}
